<template>
  <div class="gm-admin-tab">
    <div class="gm-admin-tab__head">
      <div>
        <h2>{{ $t('frontend_groovemail_admin_settings_message_settings') }}</h2>
        <p class="gm-admin-tab__hint">{{ $t('frontend_groovemail_admin_configure_settings') }}</p>
      </div>
      <gs-button variant="primary" @click="saveDefaultMessages()">{{ $t('frontend_save') }}</gs-button>
    </div>

    <div class="gm-admin-tab__stack gm-admin-form">
      <gs-field :label="$t('frontend_groovemail_admin_settings_for_DMARC')">
        <text-area
          variant="base"
          v-model="model.dmarc_message"
          @input="messagesUpdated = true"
          :placeholder="$t('frontend_groovemail_admin_settings_enter_message')"
          rows="3"
        />
        <p
          v-if="dataSaved && (!model.dmarc_message || !model.dmarc_message.trim())"
          class="gm-admin-tab__error"
        >
          {{ $t('frontend_groovemail_admin_settings_default_dmarc_message_required') }}
        </p>
      </gs-field>

      <gs-field :label="$t('frontend_groovemail_admin_settings_for_blocked_domains_inside_email')">
        <text-area
          variant="base"
          v-model="model.blocked_domain_default_message"
          @input="messagesUpdated = true"
          :placeholder="this.$t('frontend_groovemail_admin_settings_enter_message')"
          rows="3"
        />
        <p
          v-if="dataSaved && (!model.blocked_domain_default_message || !model.blocked_domain_default_message.trim())"
          class="gm-admin-tab__error"
        >
          {{ $t('frontend_groovemail_admin_settings_default_message_required') }}
        </p>
      </gs-field>

      <gs-field :label="$t('frontend_groovemail_admin_settings_for_import_leads_success')">
        <text-area
          variant="base"
          v-model="model.import_lead_success_message"
          @input="messagesUpdated = true"
          :placeholder="this.$t('frontend_groovemail_admin_settings_enter_message')"
          rows="3"
        />
        <p
          v-if="dataSaved && (!model.import_lead_success_message || !model.import_lead_success_message.trim())"
          class="gm-admin-tab__error"
        >
          {{ $t('frontend_groovemail_admin_settings_import_lead_message_required') }}
        </p>
      </gs-field>
    </div>
  </div>
</template>

<script>
import { adminUrls } from '@/utils/urls.js';
import { getData, postData } from '@/utils/apiHelper.js';
import { showErrorDialog } from '@/components/showDialog.js';

export default {
  data() {
    return {
      model: {
        dmarc_message: '',
        blocked_domain_default_message: '',
        import_lead_success_message: '',
      },
      dataSaved: false,
      messagesUpdated: false,
    };
  },

  // Initialize data properties with custom message data.
  async created() {
    await this.initializeMessagesData();
  },
  
  methods: {
    // Fetches message data and initializes them to data properties.
    async initializeMessagesData() {
      const messages = await getData(adminUrls.mainSettingsUrl.fetchMessagesData);
      this.model.dmarc_message = messages.data && messages.data.dmrc_message;
      this.model.blocked_domain_default_message =
        messages.data && messages.data.domain_inside_email_body_message;
      this.model.import_lead_success_message =
        messages.data && messages.data.import_lead_success;
    },

    // Used to save message data.
    async saveDefaultMessages() {
      this.dataSaved = true;
      if (this.messagesUpdated) {
        if (
          this.dataSaved &&
          this.model.dmarc_message &&
          this.model.dmarc_message.trim() &&
          this.model.blocked_domain_default_message &&
          this.model.blocked_domain_default_message.trim() &&
          this.model.import_lead_success_message &&
          this.model.import_lead_success_message.trim()
        ) {
	        await postData(adminUrls.mainSettingsUrl.updateMessagesData, {
            dmarc_message: this.model.dmarc_message.trim(),
            domain_mail_body_message: this.model.blocked_domain_default_message.trim(),
            import_lead_success: this.model.import_lead_success_message.trim(),
          });
          this.messagesUpdated = false;
        }
      } else {
	        await showErrorDialog(
          '',
          this.$t('frontend_groovemail_admin_default_messages_update_warning')
        );        
      }
    },
  },
};
</script>